import { render, staticRenderFns } from "./integralOrderGoods.vue?vue&type=template&id=6a1ff201"
import script from "./integralOrderGoods.vue?vue&type=script&lang=js"
export * from "./integralOrderGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports